import { Axios } from '../api';
import { REGISTERS_API_URL } from '../constants';
import { useSubscriptionStore } from '../store';
import { type SubscriptionInfo } from '../types';

export class SubscriptionService {
    async fetchAndUpdate() {
        const response = await Axios.get<SubscriptionInfo>(
            REGISTERS_API_URL.SUBSCRIPTION.STATUS,
        );

        const subscriptionStore = useSubscriptionStore.getState();
        subscriptionStore.update(response.data);
    }
}
